import React from "react";
import styled from "styled-components";
import {kpiBackgroundColour} from "../../../../style/styleConsts";

const Row = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    
    border-bottom: 1px solid #d6d0c8;
`;

const ClickableRow = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    
    cursor: pointer;
    transition: background-color 0.2s ease;
    :hover {
        background-color: #f5f2f0;
    }
    :active {
        background-color: #f0ece9;
    }
    
    border-bottom: 1px solid #d6d0c8;
`;

const SelectedRow = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    
    background-color: ${kpiBackgroundColour};
    border-bottom: 1px solid #d6d0c8;
    box-shadow: 0 2px 6px 0 rgba(159,167,178,0.5);
    z-index: 2;
`;

export const RankingRow = ({isSelectedRow, children, style, onClick}) => {
    if (isSelectedRow) {
        return <SelectedRow className="t-selected-ranking-row" style={style}>
            {children}
        </SelectedRow>;
    }

    return onClick
           ? <ClickableRow className="t-ranking-row t-clickable-ranking-row" style={style} onClick={onClick}>{children}</ClickableRow>
           : <Row className="t-ranking-row" style={style} onClick={onClick}>{children}</Row>;
};